import styled from 'styled-components';
import { breakpoint } from 'styled-components-breakpoint';

export const OnboardingContent = styled.div`
  box-shadow: rgba(0, 0, 0, 0.23) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 5px;
  border: 3px solid var(--light-blue);
  background-image: url('/pre-auth-bg.svg');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 10px;
  margin: 10px;
`;

export const OnboardingImage = styled.img`
  ${breakpoint('desktop')`
    width: 300px;
  `}
`;

export const SectionTitle = styled.span`
  color: var(--offer1-green);
  font-size: 48px;
  font-weight: bold;
  text-align: center;

  ${breakpoint('xs', 'md')`
    font-size: 36px;
  `}
`;

export const SectionText = styled.p`
  font-size: 14px;
  color: var(--gray1);
  text-align: center;
`;
